// extracted by mini-css-extract-plugin
export default {"InputRequirementBuilder":"InputRequirementBuilder_InputRequirementBuilder__z7ph-"};